import Single from './Single';
import SingleCard from './SingleCard';
import SingleImage from './SingleImage';

export default {
  SINGLE: Single,
  SINGLE_IMAGE: SingleImage,
  SINGLE_CARD: SingleCard,
};
